import HomePage, { getServerSideProps as homeGetServerSideProps } from './index';

export const getServerSideProps = homeGetServerSideProps;

export default HomePage;
